import React, { Dispatch, SetStateAction, useState } from "react";
import {
  Box,
  Button,
  Divider,
  Grid,
  Typography,
  Stack,
  Tooltip
} from "@mui/material";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

import ResourceTable, { IGenerateColumns } from "../../Components/ResourceTable";
import Card from "../../Components/Card";
import AddProfile from "./AddProfile";
import RemoveProfile from "./RemoveProfile";
import ManagePermissions from "./ManagePermissions";
import EditProfileDescription from "./EditProfileDescription";
import EditProfileTitle from "./EditProfileTitle";
import { accessProfile } from "../../Requests";

const ResourceAccessProfile: React.FC = () => {
  const [idAccessProfileEdit, setIdAccessProfileEdit] = useState<number | null>(null);
  const [idProfileRemove, setIdProfileRemove] = useState<number>(0);
  const [profileName, setProfileName] = useState<string>("");
  const [rechargeRequest, setRechargeRequest] = useState<number>(0);

  const reloadResourceTable = () => setRechargeRequest((n) => n + 1);

  const handleEditPermissions = (setLoading: Dispatch<SetStateAction<boolean>>) =>
    async (id: number, name: string) => {
      setLoading(true);
      setIdAccessProfileEdit(id);
      setProfileName(name);
      setLoading(false);
    };

  const handleRemoveProfile = (setLoading: Dispatch<SetStateAction<boolean>>) =>
    async (id: number) => {
      setIdProfileRemove(id);
    };

  const generateColumns: IGenerateColumns = ({ setLoading }) => [
    {
      field: "description",
      headerName: "Descrição",
      minWidth: 250,
      flex: 3
    },
    {
      field: "acao_editar_profile",
      headerName: "Editar Permissões",
      align: "center",
      headerAlign: "center",
      flex: 1,
      width: 160,
      renderCell: (params: any) => (
        <Tooltip title="Editar permissões">
          <Box
            sx={{ cursor: "pointer" }}
            onClick={() =>
              handleEditPermissions(setLoading)(
                params?.row?.id || 0,
                params?.row?.description || ""
              )
            }
          >
            <AdminPanelSettingsIcon sx={{ color: "#1c2e4a" }} />
          </Box>
        </Tooltip>
      )
    },
    {
      field: "acao_remover",
      headerName: "Remover",
      align: "center",
      headerAlign: "center",
      flex: 1,
      width: 160,
      renderCell: (params: any) => (
        <Tooltip title="Remover perfil">
          <Box
            sx={{ cursor: "pointer" }}
            onClick={() => handleRemoveProfile(setLoading)(params?.row?.id)}
          >
            <DeleteForeverIcon sx={{ color: "#dc3545" }} />
          </Box>
        </Tooltip>
      )
    }
  ];

  return (
    <>
      {idAccessProfileEdit ? (
        <>
          <EditProfileTitle back={() => setIdAccessProfileEdit(null)} />
          <EditProfileDescription
            idProfile={idAccessProfileEdit}
            profileName={profileName}
            setProfileName={setProfileName}
          />
          <ManagePermissions idProfile={idAccessProfileEdit} />
        </>
      ) : (
        <>
          <AddProfile reloadResourceTable={reloadResourceTable} />

          <Card
            titleDashboard="Listagem de Perfis de Acesso"
            icon="RecentActorsIcon"
            paperConfig={{ minHeight: 704 }}
            marginTop="0"
            lineDividerHeader={false}
          >
            <ResourceTable
              request={accessProfile}
              generateColumns={generateColumns}
              pageSizeOptions={[10]}
              getRowId={(row) => row?.id}
              minHeight={630}
              rechargeRequest={rechargeRequest}
              autoPageSize
              filterDefinitions={({ page, recordsPerPage }) => ({
                page,
                recordsPerPage
              })}
            />

            {idProfileRemove > 0 && (
              <RemoveProfile
                idProfile={idProfileRemove}
                reloadResourceTable={reloadResourceTable}
                close={() => setIdProfileRemove(0)}
              />
            )}
          </Card>
        </>
      )}
    </>
  );
};

export default ResourceAccessProfile;
